// 节点之后线的类型
export var NodeLineType;
(function (NodeLineType) {
    NodeLineType[NodeLineType["INSERT"] = 0] = "INSERT";
    NodeLineType[NodeLineType["SHRINK"] = 1] = "SHRINK";
})(NodeLineType || (NodeLineType = {}));
// 组件枚举
export var ComponentType;
(function (ComponentType) {
    ComponentType["GRAPH_NODE"] = "graphNode";
    ComponentType["SHRINK_EXPAND"] = "shrinkExpand";
    ComponentType["INSERT"] = "insert";
    ComponentType["APPEND"] = "append";
})(ComponentType || (ComponentType = {}));
// 方向枚举
export var Direction;
(function (Direction) {
    Direction[Direction["TOP"] = 0] = "TOP";
    Direction[Direction["RIGHT"] = 1] = "RIGHT";
    Direction[Direction["BOTTOM"] = 2] = "BOTTOM";
    Direction[Direction["LEFT"] = 3] = "LEFT";
})(Direction || (Direction = {}));
export var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType[TreeNodeType["MOLD"] = 1] = "MOLD";
    TreeNodeType[TreeNodeType["CONDITION"] = 2] = "CONDITION";
    TreeNodeType[TreeNodeType["TOOLS"] = 3] = "TOOLS";
})(TreeNodeType || (TreeNodeType = {}));
// 工具状态
export var ToolsStatusEnum;
(function (ToolsStatusEnum) {
    ToolsStatusEnum[ToolsStatusEnum["DEFAULT"] = 0] = "DEFAULT";
    ToolsStatusEnum[ToolsStatusEnum["SELECT"] = 1] = "SELECT";
    ToolsStatusEnum[ToolsStatusEnum["SELECT_ERROR"] = 2] = "SELECT_ERROR";
    ToolsStatusEnum[ToolsStatusEnum["EDIT_ERROR"] = 3] = "EDIT_ERROR";
    ToolsStatusEnum[ToolsStatusEnum["VERIFY_ERROR"] = 4] = "VERIFY_ERROR";
})(ToolsStatusEnum || (ToolsStatusEnum = {}));
// 工具中的组件枚举
export var ToolsComponentNameEnum;
(function (ToolsComponentNameEnum) {
    ToolsComponentNameEnum["SCORE_SELECT"] = "scoreSelect";
    ToolsComponentNameEnum["CONDITION_SELECT"] = "conditionSelect";
    ToolsComponentNameEnum["DAY_INPUT"] = "dayInput";
    ToolsComponentNameEnum["TIME_SELECT"] = "timeSelect";
    ToolsComponentNameEnum["RATIO_SELECT"] = "ratioSelect";
    ToolsComponentNameEnum["PRICE_SPREAD_SELECT"] = "priceSpreadSelect";
    ToolsComponentNameEnum["NUM_INPUT"] = "numInput";
})(ToolsComponentNameEnum || (ToolsComponentNameEnum = {}));
// 操作类型
export var OperationType;
(function (OperationType) {
    OperationType[OperationType["INSERT"] = 0] = "INSERT";
    OperationType[OperationType["APPEND"] = 1] = "APPEND";
})(OperationType || (OperationType = {}));
export var DeleteWayEnum;
(function (DeleteWayEnum) {
    DeleteWayEnum[DeleteWayEnum["ALL"] = 0] = "ALL";
    DeleteWayEnum[DeleteWayEnum["SELF"] = 1] = "SELF";
})(DeleteWayEnum || (DeleteWayEnum = {}));
